jQuery_T4NT(document).ready(function($) {

const priceDiv = document.querySelector('.t4s-product__price-review');
const breadDiv = document.querySelector('[id*="bread_pay_messaging_app_block_product"]');

if (priceDiv && breadDiv) {
    // Create wrapper div
    const wrapper = document.createElement('div');
    wrapper.className = 'price-payment-wrapper';
    wrapper.style.display = 'flex';
    wrapper.style.alignItems = 'center';
    wrapper.style.justifyContent = 'space-between';
    wrapper.style.gap = '20px';
    wrapper.style.flexWrap = 'wrap';
    
    // Use CSS custom properties for responsive behavior
    wrapper.style.setProperty('--justify-content-unwrapped', 'space-between');
    wrapper.style.setProperty('--justify-content-wrapped', 'center');
    
    // Add media query logic via CSS
    const style = document.createElement('style');
    style.textContent = `
        .price-payment-wrapper {
            justify-content: var(--justify-content-unwrapped) !important;
        }
        
        /* When items wrap, center them */
        @supports (container-type: inline-size) {
            .price-payment-wrapper {
                container-type: inline-size;
            }
        }
        
        /* Fallback: assume wrapping occurs at smaller widths */
        @media (max-width: 768px) {
            .price-payment-wrapper {
                justify-content: var(--justify-content-wrapped) !important;
            }
        }
    `;
    document.head.appendChild(style);
    
    // Insert wrapper before the first div
    priceDiv.parentNode.insertBefore(wrapper, priceDiv);
    
    // Move both divs into the wrapper (breadDiv first to reverse order)
    wrapper.appendChild(breadDiv);
    wrapper.appendChild(priceDiv);
}
});


